import React, { useEffect } from 'react';
import styled from 'styled-components';
import { useModalStore } from '../../shared/store/portal/modalStore';
import { slideInFromLeftWeighted } from '../../shared/component/Animation';
import { useImportStationTextStore } from '../../shared/store/importStationTextStore';
import { useProjectDetailState } from '../../shared/hooks/useApi/useProjectDetail';
import { useCanShowProjectDetail } from '../../shared/hooks/useProjectVisibility';
import { useModalPageStore } from '../../shared/store/pageStore';
import ImportStationTextSub from './ImportStationTextSub';
import ImportStationTextMain from './ImportStationTextMain';
import { paperTextureModal } from '../../shared/component/paperTexture';

const ImportStationTexts: React.FC = () => {
  const { isClosing } = useModalStore();
  const { selectedId, clearSimpleList } = useImportStationTextStore();
  const { project } = useProjectDetailState();
  const canShowProject = useCanShowProjectDetail();
  const resetModalPage = useModalPageStore((s) => s.resetModalPage);

  useEffect(() => () => {
    clearSimpleList();
    resetModalPage();
  }, []);

  if (!canShowProject || !project) return null;

  return (
    <LeftModalFrame
      onClick={(e) => e.stopPropagation()}
      $isClosing={isClosing}
      $hasSub={selectedId !== ""}
    >
      <ImportComp>
        <ImportStationTextMain />
        <ImportStationTextSub />
      </ImportComp>
    </LeftModalFrame>
  );
};

export const LeftModalFrame = styled.div<{ $isClosing: boolean; $hasSub: boolean }>`
  position: absolute;
  left: 4vw;
  width: ${({ $hasSub }) => ($hasSub ? 'calc(60vw + 60px)' : 'calc(24vw + 40px)')};
  min-width: ${({ $hasSub }) => ($hasSub ? '700px' : '300px')};
  max-width: ${({ $hasSub }) => ($hasSub ? '700px' : '300px')};
  height: 85vh;
  
  padding: 20px;
  

  opacity: ${({ $isClosing }) => ($isClosing ? 0 : 1)};
  transform: ${({ $isClosing }) =>
    $isClosing
      ? 'translateX(-100%)'
      : 'translateX(0)'
  };

  transition: all 0.6s ease-out;
  ${paperTextureModal}
  ${slideInFromLeftWeighted}
`;

const ImportComp = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  overflow: hidden;
`;

export default ImportStationTexts;
